import React, { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

const AboutDoorsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('materijali');

  const doorTypes = [
    {
      id: 1,
      title: "Rezidencionalna Vrata",
      description: "Idealna za stambene objekte, kombinuju funkcionalnost sa estetikom",
      features: ["Toplotna izolacija", "Zvučna izolacija", "Različite boje", "Daljinski upravljač"],
      image: "https://readdy.ai/api/search-image?query=residential%20sectional%20garage%20door%20modern%20home%20elegant%20white%20door%20professional%20installation%20quality%20materials%20beautiful%20architecture&width=400&height=300&seq=30&orientation=landscape"
    },
    {
      id: 2,
      title: "Industrijska Vrata",
      description: "Robusna rešenja za skladišta, fabrike i industrijske objekte",
      features: ["Visoka izdržljivost", "Brza montaža", "Bezbednosni sistemi", "Velika nosivost"],
      image: "https://readdy.ai/api/search-image?query=industrial%20sectional%20garage%20door%20warehouse%20facility%20heavy%20duty%20door%20professional%20installation%20commercial%20use%20robust%20materials&width=400&height=300&seq=31&orientation=landscape"
    },
    {
      id: 3,
      title: "Protivpožarna Vrata",
      description: "Specijalizovana vrata koja pružaju zaštitu u slučaju požara",
      features: ["Sertifikacija EI-60", "Automatsko zatvaranje", "Dim blokada", "Bezbednosni sistemi"],
      image: "https://readdy.ai/api/search-image?query=fire-rated%20sectional%20garage%20door%20industrial%20safety%20door%20professional%20installation%20fire%20protection%20quality%20materials%20security%20system&width=400&height=300&seq=32&orientation=landscape"
    },
    {
      id: 4,
      title: "Brza Vrata",
      description: "Specijalizovana rešenja za objekte sa intenzivnim saobraćajem",
      features: ["Velika brzina", "Frekventno korišćenje", "Energetska efikasnost", "Automatizacija"],
      image: "https://readdy.ai/api/search-image?query=high-speed%20sectional%20garage%20door%20rapid%20opening%20door%20industrial%20facility%20professional%20installation%20efficient%20operation%20modern%20technology&width=400&height=300&seq=33&orientation=landscape"
    }
  ];

  const tabContent = {
    materijali: {
      title: "Materijali i Konstrukcija",
      content: [
        {
          subtitle: "Paneli",
          description: "Paneli su izrađeni od visokokvalitetnog čelika debljine 0,5mm sa poliuretanskim jezgrom koje obezbeđuje odličnu toplotnu i zvučnu izolaciju.",
          specs: ["Čelični lim 0,5mm", "Poliuretansko jezgro", "Koeficijent prolaska toplote U=0,6 W/m²K", "Debljina panela 40mm"]
        },
        {
          subtitle: "Vodilice i Šine",
          description: "Precizno izrađene vodilice od pocinkovane čelične trake omogućavaju glatko i tiho funkcionisanje vrata kroz ceo životni ciklus.",
          specs: ["Pocinkovan čelik", "Precizna izrada", "Antikorozivna zaštita", "Maksimalna izdržljivost"]
        }
      ]
    },
    mehanizmi: {
      title: "Mehanizmi i Oprema",
      content: [
        {
          subtitle: "Opruge i Balansiranje",
          description: "Visokokvalitetne spiralne opruge obezbedaju optimalno balansiranje vrata i dugotrajno funkcionisanje bez potrebe za čestim servisiranjem.",
          specs: ["Spiralne opruge", "10.000+ ciklusa", "Precizno balansiranje", "Bezbednosni prekid"]
        },
        {
          subtitle: "Panele i Zglobovi",
          description: "Robusni zglobovi i panele garantuju stabilnost konstrukcije i omogućavaju bezbedan rad čak i u ekstremnim uslovima.",
          specs: ["Čelični zglobovi", "Nylon klizači", "Antikorozivna zaštita", "Testa nosivosti"]
        }
      ]
    },
    automatika: {
      title: "Automatika i Kontrola",
      content: [
        {
          subtitle: "Električni Pogon",
          description: "Napredni električni motori obezbedaju tiho i pouzdano otvaranje/zatvaranje vrata sa dugotrajnom garancijom.",
          specs: ["230V AC motor", "LED osvetljenje", "Bezbednosni senzori", "Automatska blokada"]
        },
        {
          subtitle: "Smart Funkcionalnosti",
          description: "Moderne mogućnosti uključuju Wi-Fi konekciju, aplikaciju za telefon i integraciju sa smart home sistemima.",
          specs: ["Wi-Fi povezivanje", "Mobilna aplikacija", "Google/Alexa podrška", "Notifikacije u realnom vremenu"]
        }
      ]
    },
    bezbednost: {
      title: "Bezbednosni Sistemi",
      content: [
        {
          subtitle: "Senzori Bezbednosti",
          description: "Napredni bezbednosni sistemi štite od povreda i omogućavaju bezbedan rad u svim situacijama.",
          specs: ["Foto-ćelije", "Senzor pritiska", "Automatski prekid", "LED signalizacija"]
        },
        {
          subtitle: "Mehanička Bezbednost",
          description: "Robusne mehaničke bezbednosne mere pružaju dodatnu zaštitu tokom rada i servisiranja.",
          specs: ["Bezbednosni kablovi", "Blokada opruga", "Ručno otvaranje", "Sigurnosni prekidači"]
        }
      ]
    }
  };

  const advantages = [
    {
      icon: "ri-shield-check-line",
      title: "Toplotna Izolacija",
      description: "Odlična energetska efikasnost sa U=0,6 W/m²K"
    },
    {
      icon: "ri-volume-mute-line",
      title: "Zvučna Izolacija",
      description: "Značajno smanjenje spoljašnje buke"
    },
    {
      icon: "ri-lock-line",
      title: "Visoka Bezbednost",
      description: "Napredni bezbednosni sistemi i robusna konstrukcija"
    },
    {
      icon: "ri-time-line",
      title: "Dugotrajnost",
      description: "Preko 10.000 ciklusa rada sa minimalnim održavanjem"
    },
    {
      icon: "ri-palette-line",
      title: "Dizajn Opcije",
      description: "Širok spektar boja i završnih obrada"
    },
    {
      icon: "ri-customer-service-line",
      title: "Puna Garancija",
      description: "5 godina garancije na materijal i rad"
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16 min-h-[60vh] flex items-center">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=sectional%20garage%20door%20cross-section%20technical%20view%20materials%20construction%20quality%20engineering%20professional%20installation%20industrial%20design%20manufacturing&width=1920&height=800&seq=34&orientation=landscape')`
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-black/30"></div>
        
        <div className="relative z-10 container mx-auto px-6">
          <div className="max-w-3xl">
            <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              O Segmentnim Vratima
            </h1>
            <p className="text-xl lg:text-2xl text-gray-200 mb-8 leading-relaxed">
              Sve što trebate znati o kvalitetu, materijalima i tehnologiji segmentnih vrata
            </p>
          </div>
        </div>
      </section>

      {/* Doormont Quality Section */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <div className="inline-block bg-red-600/10 rounded-lg px-4 py-2 mb-6">
                <span className="text-red-600 font-medium">Kvalitet</span>
              </div>
              
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-8 leading-tight">
                Zašto mi?
              </h2>
              
              <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                Radimo sa evropskim proizvođačima segmentnih vrata sa preko 30 godina iskustva. Montiramo vrata koja kombinuju naprednu tehnologiju, vrhunske materijale i preciznu izradu, kako bi korisnicima obezbedila dugotrajnost, sigurnost i vrhunsko iskustvo u svakodnevnoj upotrebi.
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-center">
                  <i className="ri-check-line text-2xl text-red-600 mr-4"></i>
                  <span className="text-lg text-gray-700">Evropski standardi kvaliteta</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-2xl text-red-600 mr-4"></i>
                  <span className="text-lg text-gray-700">30+ godina iskustva u proizvodnji</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-2xl text-red-600 mr-4"></i>
                  <span className="text-lg text-gray-700">Sertifikovani materijali i procesi</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-2xl text-red-600 mr-4"></i>
                  <span className="text-lg text-gray-700">Kontinuirane inovacije</span>
                </div>
              </div>
              
              
            </div>
            
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=doormont%20factory%20manufacturing%20sectional%20garage%20doors%20production%20line%20quality%20control%20european%20standards%20professional%20manufacturing%20modern%20facility&width=600&height=500&seq=35&orientation=landscape"
                alt="Proizvodnja"
                className="w-full h-96 object-cover rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Door Types Section */}
      <section className="py-24 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Tipovi Segmentnih Vrata
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Nudimo širok spektar segmentnih vrata prilagođenih različitim potrebama i objektima
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {doorTypes.map((door) => (
              <div key={door.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300">
                <div className="h-48 bg-gray-100 p-4">
                  <img
                    src={door.image}
                    alt={door.title}
                    className="w-full h-full object-cover rounded-xl"
                  />
                </div>
                
                <div className="p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    {door.title}
                  </h3>
                  
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    {door.description}
                  </p>
                  
                  <ul className="space-y-2">
                    {door.features.map((feature, index) => (
                      <li key={index} className="flex items-center text-gray-700">
                        <i className="ri-check-line text-red-600 mr-2"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Technical Specifications */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Materijali i Specifikacije
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Detaljne informacije o materijalima, mehanizmima i tehnologijama korišćenim u vratima
            </p>
          </div>

          {/* Tab Navigation */}
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {Object.entries(tabContent).map(([key, content]) => (
              <button
                key={key}
                onClick={() => setActiveTab(key)}
                className={`px-6 py-3 rounded-full font-medium transition-all duration-300 ${
                  activeTab === key
                    ? 'bg-red-600 text-white shadow-lg'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {content.title}
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div className="max-w-4xl mx-auto">
            {tabContent[activeTab as keyof typeof tabContent].content.map((section, index) => (
              <div key={index} className="mb-12 p-8 bg-gray-50 rounded-2xl">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {section.subtitle}
                </h3>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  {section.description}
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {section.specs.map((spec, specIndex) => (
                    <div key={specIndex} className="flex items-center">
                      <i className="ri-checkbox-circle-line text-red-600 mr-2"></i>
                      <span className="text-gray-700">{spec}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Advantages Section */}
      <section className="py-24 bg-red-600">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              Prednosti segmentnih vrata
            </h2>
            <p className="text-xl text-red-100 max-w-3xl mx-auto">
              Zašto su segmentna vrata najbolji izbor za vaš objekat
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {advantages.map((advantage, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center mx-auto mb-6">
                  <i className={`${advantage.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-4">
                  {advantage.title}
                </h3>
                <p className="text-red-100">
                  {advantage.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Spremni za Kvalitetna Segmentna Vrata?
          </h2>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Kontaktirajte nas za stručnu konsultaciju i besplatnu procenu koji tip vrata najbolje odgovara vašim potrebama
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              variant="primary" 
              size="lg"
              icon="ri-phone-line"
              href="tel:+381600706072"
            >
              Pozovite za Konsultacije
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              to="/usluge"
              icon="ri-service-line"
            >
              Pogledajte Usluge
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutDoorsPage;